import { channel } from 'redux-saga';
import { put, takeEvery } from 'redux-saga/effects';
import { get } from 'lodash';
// import { toast } from 'react-toastify';

import { appGoOffline, appGoOnline } from './actions';
import { IAction } from '../../interfaces/IAction';
import { API_SEND_REQUEST_ERROR } from '../../modules/api/constants';
import { getType } from 'typesafe-actions';

import * as actions from './actions';
import { REHYDRATE } from 'redux-persist';
// import { makeErrorToast } from './index';

const appOnlineChannel = channel();
const appOfflineChannel = channel();

const handleOnline = () => {
  appOnlineChannel.put(appGoOnline());
};

const handleOffline = () => {
  appOfflineChannel.put(appGoOffline());
};

const checkOnlineState = () => {
  if (navigator.onLine) {
    handleOnline();
  } else {
    handleOffline();
  }
};

const startListeningBrowserOnlineState = () => {
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
};

function apiRequestErrorWatcher(action: IAction) {
  const errorMessage = get(action, ['payload', 'errors', 'error'], 'unknown');

  if (errorMessage) {
    // toast(makeErrorToast(errorMessage), {
    //   autoClose: 3000,
    // });
  }
}

function* onAppOnline(action: ReturnType<typeof appGoOnline>) {
  yield put(action);
}

function* onAppOffline(action: ReturnType<typeof appGoOffline>) {
  yield put(action);
}

let isNetworkStatsListenerInitialized = false;

function* onStateRestored() {
  if (!isNetworkStatsListenerInitialized) {
    yield put(actions.startListeningBrowserOnlineState());
    yield put(actions.checkAppOnlineState());

    isNetworkStatsListenerInitialized = true;
  }
}

export default function* appRootSaga() {
  yield takeEvery(REHYDRATE, onStateRestored);
  yield takeEvery([getType(actions.startListeningBrowserOnlineState)], startListeningBrowserOnlineState);
  yield takeEvery([getType(actions.checkAppOnlineState)], checkOnlineState);
  yield takeEvery([API_SEND_REQUEST_ERROR], apiRequestErrorWatcher);
  yield takeEvery(appOnlineChannel, onAppOnline);
  yield takeEvery(appOfflineChannel, onAppOffline);
}



// WEBPACK FOOTER //
// ./src/containers/App/saga.ts